module.exports = __webpack_public_path__ + "images/Line_Corporation-24cea7.png";